import * as React from 'react';
import * as Styled from './MenuListButton.styles';
import { Menu } from '@mui/material';
import { useState } from 'react';
import MoreVert from '@mui/icons-material/MoreVert';
import { ArrowRight } from '@mui/icons-material';
const SubMenuList = (props) => {
    const { content, menuItems, icon, cy, closeParent } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (e) => {
        setAnchorEl(null);
        closeParent?.(e);
    };
    const menuItemClose = (onClick) => (e) => {
        handleClose(e);
        onClick();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Styled.MenuItem, { onClick: handleClick, "data-cy": cy },
            icon,
            content,
            React.createElement(ArrowRight, { className: "arrow-sub" })),
        React.createElement(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, anchorOrigin: { horizontal: 'right', vertical: 'top' } }, menuItems.map((item, index) => {
            const { text, icon, onClick } = item;
            console.log(item);
            return (React.createElement(Styled.MenuItem, { key: index, onClick: menuItemClose(onClick) },
                icon,
                text));
        }))));
};
export const MenuListButton = ({ menuItems, icon = React.createElement(MoreVert, { color: "secondary" }), transformOrigin = {
    vertical: 'top',
    horizontal: 'left',
}, anchorOrigin = {
    vertical: 'top',
    horizontal: 'left',
}, buttonAriaLabel, buttonCy, className, cy, onModalOpen, onModalClose, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (e) => {
        onModalOpen?.();
        setAnchorEl(e.currentTarget);
        e.stopPropagation();
    };
    const handleClose = (e) => {
        setAnchorEl(null);
        onModalClose?.();
        e?.stopPropagation();
    };
    const menuItemClose = (onClick) => (e) => {
        handleClose(e);
        onClick();
    };
    return (React.createElement(Styled.Wrapper, { className: className, "data-cy": cy }, menuItems && menuItems.length > 0 && (React.createElement(React.Fragment, null,
        React.createElement(Styled.MenuListButton, { "aria-label": buttonAriaLabel, "aria-haspopup": "true", onClick: handleClick, "data-cy": buttonCy }, icon),
        React.createElement(Menu, { anchorEl: anchorEl, open: !!anchorEl, onClose: handleClose, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin }, menuItems.map(({ text, onClick, icon, cy, props: menuItemProps, subMenuItems, }, i) => {
            if (subMenuItems?.length) {
                return (React.createElement(SubMenuList, { key: i, menuItems: subMenuItems, content: text, icon: icon, cy: cy, closeParent: handleClose }));
            }
            return (React.createElement(Styled.MenuItem, { ...menuItemProps, key: i, onClick: menuItemClose(onClick), "data-cy": cy },
                icon,
                text));
        }))))));
};
MenuListButton.defaultProps = {};
export default MenuListButton;
